export default __webpack_public_path__ + "static/media/Outbreak.563d123e.svg";